import common from './common';
import table from './table';
import formValidations from './formValidations';
import home from './pagesTranslations/home';
import auth from './pagesTranslations/auth';
import users from './pagesTranslations/users';
import access from './pagesTranslations/access';
import settings from './pagesTranslations/settings';
import privacyPolicy from './pagesTranslations/privacyPolicy';
import bulkOperations from './pagesTranslations/bulkOperations';

export default {
  'app.accelaero': 'Accelaero',
  'app.name': 'AeroSuite',
  ...common,
  ...table,
  ...home,
  ...auth,
  ...users,
  ...access,
  ...settings,
  ...bulkOperations,
  ...privacyPolicy,
  ...formValidations
};
